<template>
    <div :class="[layout, { 'col-md-4 col-sm-12 col-xs-12': layout == 'big', 'col-md-2 col-sm-3 col-xs-4': layout == 'small' }]"
         class="card cursor-pointer">
        <div class="bg-dark" @click="redirect()">
            <v-img :item="item" :img="item.img" :key="item.img.url" :is-video="isVideo" :time="item.time" :views="item.views" :isView="item.view"></v-img>
            <h5 class="q-mt-md q-mb-xs" :class="item.category" v-html="item.title"></h5>
        </div>
        <div class="tag-box bg-dark" v-if="item.tag">
            <span class="fa fa-tags text-white" aria-hidden="true"></span>
            <router-link v-for="(tag, keys) in item.tag" :key="keys" :to="'/video/category/'+keys">
                  {{tag}}
            </router-link>
        </div>
        <p v-if="item.subtitle" class="q-ma-none" v-html="item.subtitle"></p>
    </div>
</template>

<script>
    export default {
        name: 'VCard',

        props: {
            layout: {
                type: String,
                required: true
            },
            item: {
                type: Object,
                required: true
            },
            isVideo: Boolean,
        },
        methods: {
            redirect() {
                window.location.href = config.appUrlPortal + this.item.uri
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/front/Card.vue